import { render, staticRenderFns } from "./BaseToggleStatusBarriers.vue?vue&type=template&id=6ce3c11c&scoped=true"
import script from "./BaseToggleStatusBarriers.vue?vue&type=script&lang=js"
export * from "./BaseToggleStatusBarriers.vue?vue&type=script&lang=js"
import style0 from "./BaseToggleStatusBarriers.vue?vue&type=style&index=0&id=6ce3c11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce3c11c",
  null
  
)

export default component.exports